import { createFileRoute, notFound } from '@tanstack/react-router';
import { ModulePlaceholder } from '@/features/misc/module-placeholder';
import { MODULE_PHASE } from '@/components/shell/nav';

export const Route = createFileRoute('/_app/$module')({
  beforeLoad: ({ params }) => {
    if (!(params.module in MODULE_PHASE)) throw notFound();
  },
  component: function Module() {
    const { module } = Route.useParams();
    return <ModulePlaceholder module={module} />;
  },
});
